var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-color",style:(_vm.tagStyle)},[_vm._v("\n  "+_vm._s(_vm.value)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }